import { useState, useEffect } from 'react';
import './GraduationCeremony.css';
import pic1 from "../ceremony/ceremony (2).jpg";
import pic2 from "../ceremony/ceremony (1).jpg";
import pic3 from "../ceremony/ceremony (3).jpg";
import pic4 from "../ceremony/ceremony (4).jpg";
import pic5 from "../ceremony/ceremony (5).jpg";
import pic6 from "../ceremony/ceremony (6).jpg";
import pic7 from "../ceremony/ceremony (7).jpg";
import pic8 from "../ceremony/ceremony (8).jpg";
import pic9 from "../ceremony/ceremony (9).jpg";
import pic10 from "../ceremony/ceremony (10).jpg";
import pic11 from "../ceremony/ceremony (11).jpg";
import pic12 from "../ceremony/ceremony (12).jpg";
import pic13 from "../ceremony/ceremony (13).jpg";
import pic14 from "../ceremony/ceremony (14).jpg";
import pic15 from "../ceremony/ceremony (15).jpg";

const GraduationCeremony = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [allImages, setAllImages] = useState([]);

  // Top 3 featured images
  const featuredImages = [
    { id: 1, src: pic1 , alt: 'Graduation Ceremony 1' },
    { id: 2, src: pic2 , alt: 'Graduation Ceremony 2' },
    { id: 3, src: pic3 , alt: 'Graduation Ceremony 3' }
  ];

  // Gallery images for Session 2023-24
  const galleryImages = [
    { id: 4, src: pic4 , alt: 'Graduates 4' },
    { id: 5, src: pic5 , alt: 'Graduates 5' },
    { id: 6, src: pic6 , alt: 'Graduates 6' },
    { id: 7, src: pic7 , alt: 'Graduates 7' },
    { id: 8, src: pic8 , alt: 'Graduates 8' },
    { id: 9, src: pic9 , alt: 'Graduates 9' },
    { id: 10, src: pic10 , alt: 'Graduates 10' },
    { id: 11, src: pic11 , alt: 'Graduates 11' },
    { id: 12, src: pic12 , alt: 'Graduates 12' },
    { id: 13, src: pic13 , alt: 'Graduates 13' },
    { id: 14, src: pic14 , alt: 'Graduates 14' },
    { id: 15, src: pic15 , alt: 'Graduates 15' },
  ];

  useEffect(() => {
    // Combine all images
    const combined = [...featuredImages, ...galleryImages];
    setAllImages(combined);
  }, []);

  const handleImageClick = (imageSrc) => {
    const imageIndex = allImages.findIndex(image => image.src === imageSrc);
    setCurrentImageIndex(imageIndex);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % allImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + allImages.length) % allImages.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentImageIndex === null) return;
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentImageIndex, allImages.length]);

  return (
    <>
     {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>CEREMONY</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Ceremony</li>
          </ul>
        </div>
      </section>
      {/* Main Content */}
      <div className="grad-container">
        {/* Title Section */}
        <div className="grad-title-section">
          <h2>CEREMONY</h2>
          <div className="grad-title-underline"></div>
        </div>

        {/* Featured Section with Images and Content Alternating */}
        <section className="grad-featured">
          {/* First Section - Image Left, Content Right */}
          <div className="grad-feature-row">
            <div className="grad-feature-image" onClick={() => handleImageClick(featuredImages[0].src)}>
              <img src={featuredImages[0].src} alt={featuredImages[0].alt} />
            </div>
            <div className="grad-feature-content">
              <h3>A Momentous Celebration</h3>
              <p>
                The Ceremony at Bhani Children's Academy is a momentous occasion that celebrates 
                the achievements and growth of our young learners. This special event marks an important 
                milestone in their educational journey as they transition from one level to the next.
              </p>
              <p>
                The ceremony is filled with pride, joy, and emotion as students don their graduation caps 
                and gowns, receive their certificates, and are recognized for their hard work and dedication.
              </p>
            </div>
          </div>

          {/* Second Section - Content Left, Image Right */}
          <div className="grad-feature-row">
            <div className="grad-feature-content">
              <h3>Pride & Achievement</h3>
              <p>
                Parents, teachers, and guests come together to applaud the accomplishments of these young 
                graduates. The atmosphere is charged with excitement and anticipation as each child's name 
                is called to receive their well-earned certificate.
              </p>
              <p>
                Our ceremony not only honors academic excellence but also celebrates the personal 
                development and character building of each student throughout their time at the academy.
              </p>
            </div>
            <div className="grad-feature-image" onClick={() => handleImageClick(featuredImages[1].src)}>
              <img src={featuredImages[1].src} alt={featuredImages[1].alt} />
            </div>
          </div>

          {/* Third Section - Image Left, Content Right */}
          <div className="grad-feature-row">
            <div className="grad-feature-image" onClick={() => handleImageClick(featuredImages[2].src)}>
              <img src={featuredImages[2].src} alt={featuredImages[2].alt} />
            </div>
            <div className="grad-feature-content">
              <h3>Memories to Cherish</h3>
              <p>
                The ceremony day is filled with memorable moments - from the traditional cap toss to 
                heartfelt speeches and emotional farewells. These precious memories are captured through 
                photographs and videos that families treasure forever.
              </p>
              <p>
                It's a day when our young graduates shine bright, dressed in their ceremonial robes, 
                standing tall with confidence as they step into the next chapter of their educational journey.
              </p>
            </div>
          </div>
        </section>

        {/* Session Gallery */}
        <section className="grad-gallery-section">
         
          
          <div className="grad-gallery">
            {galleryImages.map((image, index) => (
              <div 
                key={image.id} 
                className={`grad-gallery-item ${index % 2 === 0 ? 'grad-left' : 'grad-right'}`}
                onClick={() => handleImageClick(image.src)}
              >
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {currentImageIndex !== null && allImages[currentImageIndex] && (
        <div className="image-modal show" onClick={(e) => e.target.classList.contains('image-modal') && closeModal()}>
          <div className="modal-content-wrapper">
            <button className="modal-close-btn" onClick={closeModal}>&times;</button>
            <button className="modal-nav-btn modal-prev-btn" onClick={prevImage}>❮</button>
            <img 
              className="modal-image-display" 
              src={allImages[currentImageIndex].src} 
              alt={allImages[currentImageIndex].alt}
            />
            <button className="modal-nav-btn modal-next-btn" onClick={nextImage}>❯</button>
            <div className="modal-counter-display">
              <span id="current">{currentImageIndex + 1}</span> / <span id="total">{allImages.length}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GraduationCeremony;